import React from 'react'
import {withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import ConditionElement from './ConditionElement';
import GridBlock from 'components/GridBlock';
import Tr from 'translations/Translations';
import TextInput from 'components/TextInput';
import {CRYTERIUM_TYPE} from "components/popup/newCriteria/constants/criterium.type";
import getObjectValue from "libs/getObjectValue";
import INPUT_TYPE from "constants/INPUT_TYPE";
import {isDemandPreparing} from "libs/getDemandStatus";

const style = theme => ({
    root: {},
    weightInput: {
        width: 100
    }
})

function CriteriaElement(
    {
        classes,
        formikProps,
        name,
        type,
        id,
        index,
        onEdit,
        onDelete,
        disabled,
    }) {

    const onWeightChange = (val) => {

        const critArray = getObjectValue(id, formikProps.values, []);
        let priceIndex = -1;
        let sum = critArray.reduce((prev, cur, curIndex) => {
            let newSum = prev;
            if (cur.type === CRYTERIUM_TYPE.PRICE) {
                priceIndex = curIndex;
            } else {
                if (curIndex === index) {
                    newSum += parseFloat(val);
                } else {
                    newSum += parseFloat(cur.weight);
                }
            }
            return newSum;
        }, 0);
        sum = parseFloat(sum.toFixed(2));
        const priceWeight = (100 - sum) < 0 ? 0 : 100 - sum;
        const priceWeightId = `${id}.${priceIndex}.weight`;
        formikProps.setFieldValue(priceWeightId, priceWeight);
    }

    const weightId = `${id}.${index}.weight`
    return (
        <GridBlock
            className={classes.root}
            column
        >
            <ConditionElement
                name={name}
                formikProps={formikProps}
                id={id}
                index={index}
                onEdit={onEdit}
                onDelete={onDelete}
                disableDelete={type === CRYTERIUM_TYPE.PRICE}
                disabled={disabled}
            />
            <TextInput
                className={classes.weightInput}
                id={weightId}
                label={Tr('weight')}
                formikProps={formikProps}
                endAdornment='%'
                type={INPUT_TYPE.NUMBER_19}
                step="0.01"
                disabled={type === CRYTERIUM_TYPE.PRICE || !isDemandPreparing()}
                onChange={type === CRYTERIUM_TYPE.PRICE ? undefined : onWeightChange}
            />
        </GridBlock>
    )
}

CriteriaElement.propTypes = {
    classes: PropTypes.any,
}

export default withStyles(style)(CriteriaElement);